/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AttributeDefinitionForString extends models.AttributeDefinitionBase {
    constructor() {
        super();
        this.setDiscriminator("AttributeDefinitionForString");
    }

    getFixupPrototypeFunction() { return AttributeDefinitionForString.fixupPrototype; }

    static newInstance(model: Partial<AttributeDefinitionForString>): AttributeDefinitionForString {
        let obj = Object.assign(new AttributeDefinitionForString(), model);
        AttributeDefinitionForString.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AttributeDefinitionForString>): AttributeDefinitionForString {
        if (!model) return null;
        return AttributeDefinitionForString.newInstance(<AttributeDefinitionForString> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AttributeDefinitionForString) {
        if (!obj) return;

        models.AttributeDefinitionForString.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AttributeDefinitionForString): boolean {
        if (models.AttributeDefinitionBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AttributeDefinitionForString.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Is it a multi select field
     */
    is_multiple_values_allowed: boolean;

    /**
     * Possible values for the field
     */
    allowed_values: Array<string>;

}
